var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path2, _path3, _path4, _path5, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Australia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M44,24c0,11.046-8.954,20-20,20S4,35.046,4,24c0-2.216,0.36-4.348,1.026-6.341 C6.311,13.812,14.489,11,14.489,11s0.04-4.693,1.507-5.334C18.447,4.594,21.154,4,24,4C35.046,4,44,12.954,44,24z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "13,28 13.594,29.891 15.406,29.188 14.332,30.844 16,31.859 14.07,32.031 14.336,34 13,32.559 11.664,34 11.93,32.031 10,31.859 11.668,30.844 10.594,29.188 12.406,29.895"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "34.5,31 34.797,31.945 35.703,31.594 35.168,32.422 36,32.93 35.035,33.016 35.168,34 34.5,33.281 33.832,34 33.965,33.016 33,32.93 33.832,32.422 33.297,31.594 34.203,31.945"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "29.465,21.984 29.762,22.93 30.668,22.578 30.133,23.406 30.965,23.914 30,24 30.133,24.984 29.465,24.266 28.797,24.984 28.93,24 27.965,23.914 28.801,23.406 28.262,22.578 29.168,22.93"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "34.5,16 34.797,16.945 35.703,16.594 35.168,17.422 36,17.93 35.035,18.016 35.168,19 34.5,18.281 33.832,19 33.965,18.016 33,17.93 33.832,17.422 33.297,16.594 34.203,16.945"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "40.5,21 40.797,21.945 41.703,21.594 41.168,22.422 42,22.93 41.035,23.016 41.168,24 40.5,23.281 39.832,24 39.965,23.016 39,22.93 39.832,22.422 39.297,21.594 40.203,21.945"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "37,25 37.273,25.707 38,25.766 37.445,26.258 37.617,27 37,26.598 36.383,27 36.555,26.258 36,25.766 36.727,25.707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16,8.594V5.675c-1.432,0.626-2.767,1.424-4,2.352V8.31l-0.206-0.128 c-3.105,2.399-5.483,5.683-6.753,9.483L12,13.32V18h4v-4.965L23.949,18H25v-2.609L21.171,13H25V9h-4.421L25,6.238V4.05 C24.667,4.034,24.338,4,24,4c-0.235,0-0.464,0.027-0.697,0.035L16,8.594z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M13,12v6h2v-6h10v-2H15V6.157c-0.689,0.348-1.36,0.725-2,1.148V10H9.729 c-0.613,0.625-1.174,1.299-1.701,2H13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M11.641,13H9.898l-3.972,2.479c-0.229,0.484-0.437,0.977-0.627,1.481L11.641,13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M24.213,4.011L16.223,9h1.746L25,4.609V4.05C24.738,4.037,24.478,4.014,24.213,4.011z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "25,15.934 20.301,13 18.559,13 25,17.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Australia);
export default __webpack_public_path__ + "static/media/icons8-australia.7dbc6b7fbc5db93418de09ff4e25480c.svg";
export { ForwardRef as ReactComponent };